import React from 'react'
import MedalInput from './index'

export default function OrderMedalInput({ order, displayCurrentMedals = false, refetch }) {
  return (
    <MedalInput
      item={order}
      mutationName="assignOrderMedalUses"
      itemIdField="orderId"
      displayMedalsText="La orden tiene"
      medalsStoreField="givesPickerUses"
      displayCurrentMedals={displayCurrentMedals}
      refetch={refetch}
      shouldRender={(order) => order && !['done', 'cancelled'].includes(order.status)}
    />
  )
}
